module.exports = __webpack_public_path__ + "img/i-hospital-6.6ed3d870.png";